module.exports = __webpack_public_path__ + "img/vip_icon2@3x.59544553.png";